"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import dynamic from "next/dynamic";
import { Suspense, useEffect, useState } from "react";
import { subscribeBrowserTelemetry } from "@/lib/browser-telemetry";
import { PostHogReadyContext } from "./posthog-ready-context";

const PostHogPageView = dynamic(() => import("./PostHogPageView"), {
  ssr: false,
});

function PostHogUserSync({ kindeUser, isAdmin, memberId, clientReady }) {
  useEffect(() => {
    if (!clientReady) return;
    if (!kindeUser?.id) return;

    try {
      posthog.identify(String(kindeUser.id), {
        is_admin: isAdmin,
        ...(memberId ? { member_id: memberId } : {}),
      });
    } catch {
      // Identity telemetry must not affect member/admin rendering.
    }
  }, [clientReady, kindeUser?.id, isAdmin, memberId]);

  return null;
}

export function PostHogProvider({ children, kindeUser, isAdmin, memberId }) {
  const [clientReady, setClientReady] = useState(false);

  useEffect(() => subscribeBrowserTelemetry(setClientReady), []);

  return (
    <PHProvider client={posthog}>
      <PostHogReadyContext.Provider value={clientReady}>
        <Suspense fallback={null}>
          <PostHogPageView />
        </Suspense>
        <PostHogUserSync
          kindeUser={kindeUser}
          isAdmin={isAdmin}
          memberId={memberId}
          clientReady={clientReady}
        />
        {children}
      </PostHogReadyContext.Provider>
    </PHProvider>
  );
}
